import './styles.scss'

import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import ImageWithFallBack from '@/components/ImageWithFallback'
import { isValidArray } from '@/libs/utils/array'

interface ProductDocumentsProps {
  anchorId?: string
  documents?: {
    urls?: unknown[]
    type?: string
  }[]
}

const emptyDocuments = []

function ProductDocuments(props: ProductDocumentsProps) {
  const { anchorId = '', documents = emptyDocuments } = props
  const { t } = useTranslation()
  const [hoverState, setHoverState] = useState({
    key: undefined,
    isHovered: false,
  })

  const renderProductTile = (url, type, key) => {
    const documentName = t(
      `productDetails.documentSection.documentName.${type}`,
    )

    return (
      <div key={key} className="product-details__document-tile">
        <a
          download
          className="product-details__document-tile__img__wrapper"
          href={url[0].url}
          rel="noopener noreferrer"
          target="_blank"
          onMouseEnter={() => setHoverState({ key, isHovered: true })}
          onMouseLeave={() => setHoverState({ key, isHovered: false })}
        >
          <ImageWithFallBack
            alt={documentName}
            src={url[1].url}
            className={clsx('product-details__document-tile__img__background', {
              'product-details__document-tile__img__background--hovered': key === hoverState.key
                && hoverState.isHovered,
            })}
          />
          {key === hoverState.key && hoverState.isHovered && (
            <>
              <div className="product-details__document-tile__img__button" />
              <div className="product-details__document-tile__img__overlay" />
              <div className="product-details__document-tile__img__border">
                <ImageWithFallBack alt={type} src={url[1].url} />
              </div>
            </>
          )}
        </a>
        <p className="product-details__document-tile__subtitle">
          {documentName}
        </p>
      </div>
    )
  }

  return (
    <div className="pt-4 pb-4">
      <h3 id={anchorId}>{t('productDetails.documentSection.title')}</h3>
      <div className="product-details__document-wrapper mt-4">
        {isValidArray(documents)
          ? documents.map((document_, index) =>
            renderProductTile(document_.urls, document_.type, index)
          )
          : null}
      </div>
    </div>
  )
}

export default ProductDocuments
